<app-container-transparent>

    <h2>Sincronizar Card com DB</h2>

    <div fxLayout>
        <div fxFlex="80" *ngIf="messagem" class="alert alert-danger">{{ messagem }}</div>
    </div>

    <div fxLayout="row">

        <div fxFlex="80">
            <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
                <mat-form-field style="width: 100%" appearance="outline">
                    <mat-label>ID CARD</mat-label>
                    <input autocomplete="off" formControlName="codigo"
                           matInput placeholder="ID CARD" required="true">
                </mat-form-field>

                <div>
                    <div fxFlex="85"></div>
                    <div fxFlex="5">
                        <button type="submit" class="action-steps-btn" [disabled]="false" mat-raised-button color="primary">
                            Atualizar Db
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div fxFlex="20"></div>
    </div>

</app-container-transparent>